import React from 'react'
import { useParams } from 'react-router-dom'
import { Clock, Users, ChefHat, Heart, Star } from 'lucide-react'
import { Button } from '../components/ui/Button'

const RecipeDetailPage = () => {
  const { id } = useParams()

  // Mock recipe data - will be replaced with API call
  const recipe = {
    id,
    title: "Magical Chocolate Chip Cookies",
    description: "Warm, gooey cookies that taste like childhood dreams",
    cookTime: 25,
    servings: 12,
    difficulty: "easy",
    category: "Dessert",
    rating: 4.9,
    image: "https://images.unsplash.com/photo-1558961363-fa8fdf82db35?w=800&h=600&fit=crop&auto=format",
    chef: { name: "Emma Baker", avatar: null },
    ingredients: [
      "2 cups all-purpose flour",
      "1 cup butter, softened",
      "3/4 cup brown sugar",
      "1/2 cup white sugar",
      "2 large eggs",
      "2 tsp vanilla extract",
      "1 tsp baking soda",
      "1 tsp salt",
      "2 cups chocolate chips"
    ],
    steps: [
      "Preheat oven to 375°F and line baking sheets with parchment paper",
      "In a large bowl, cream together butter and both sugars until light and fluffy",
      "Beat in eggs one at a time, then add vanilla extract",
      "In a separate bowl, whisk together flour, baking soda, and salt",
      "Gradually mix dry ingredients into wet ingredients",
      "Fold in chocolate chips",
      "Drop rounded tablespoons of dough onto prepared baking sheets",
      "Bake for 9-11 minutes until edges are golden brown",
      "Cool on baking sheet for 5 minutes before transferring to wire rack"
    ]
  }

  return (
    <div className="max-w-4xl mx-auto space-y-8">
      {/* Recipe Header */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div>
          <img
            src={recipe.image}
            alt={recipe.title}
            className="w-full h-64 lg:h-80 object-cover rounded-3xl shadow-playful"
          />
        </div>

        <div className="space-y-4">
          <h1 className="text-4xl font-display font-bold text-dreamy">
            {recipe.title}
          </h1>

          <p className="text-lg text-gray-600">
            {recipe.description}
          </p>

          <div className="grid grid-cols-2 gap-4 text-sm">
            <div className="flex items-center space-x-2">
              <Clock className="w-4 h-4 text-gray-500" />
              <span>{recipe.cookTime} mins</span>
            </div>
            <div className="flex items-center space-x-2">
              <Users className="w-4 h-4 text-gray-500" />
              <span>{recipe.servings} servings</span>
            </div>
            <div className="flex items-center space-x-2">
              <ChefHat className="w-4 h-4 text-gray-500" />
              <span className="capitalize">{recipe.difficulty}</span>
            </div>
            <div className="flex items-center space-x-2">
              <Star className="w-4 h-4 text-yellow-400 fill-current" />
              <span>{recipe.rating}</span>
            </div>
          </div>

          <div className="flex gap-3 pt-4">
            <Button className="flex-1">
              <Heart className="w-4 h-4 mr-2" />
              Save Recipe
            </Button>
            <Button variant="secondary">
              Generate Images
            </Button>
          </div>
        </div>
      </div>

      {/* Ingredients & Instructions */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        <div className="card-dreamy">
          <h2 className="text-xl font-display font-semibold mb-4">Ingredients</h2>
          <ul className="space-y-2">
            {recipe.ingredients.map((ingredient, index) => (
              <li key={index} className="flex items-start space-x-2">
                <span className="w-2 h-2 bg-primary-500 rounded-full mt-2 flex-shrink-0" />
                <span className="text-sm text-gray-700">{ingredient}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-2 card-dreamy">
          <h2 className="text-xl font-display font-semibold mb-4">Instructions</h2>
          <ol className="space-y-4">
            {recipe.steps.map((step, index) => (
              <li key={index} className="flex space-x-3">
                <span className="flex-shrink-0 w-6 h-6 bg-primary-500 text-white rounded-full flex items-center justify-center text-sm font-medium">
                  {index + 1}
                </span>
                <span className="text-sm text-gray-700 pt-0.5">{step}</span>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </div>
  )
}

export default RecipeDetailPage